// extracted by mini-css-extract-plugin
export default {"del":"NewVariantDel_del__l1o6y","svg":"NewVariantDel_svg__EnRF+"};